import { IChatUserDto, ICreateChatBody, ICreateChatResponse, IFetchArchivedChatParams, IFetchChatParams, IProfileChatDto, ISellProductOffers, IUpdateChatParams } from "@/Models/Chat";
import apiService from "../ApiService";


async function getChats(params: IFetchChatParams) {
  return await apiService
    .setUrl(`/chats`)
    .setMethod("GET")
    .setParams(params)
    .request<ISellProductOffers>();
};
async function getChatById(chatId: number) {
  return await apiService
    .setUrl(`/chats/${chatId}`)
    .setMethod("GET")
    .request<IChatUserDto>();
};
async function createChat(body: ICreateChatBody) {
  return await apiService
    .setUrl(`/chats`)
    .setMethod("POST")
    .setBody(body)
    .request<ICreateChatResponse>();
};
async function updateChat(params: IUpdateChatParams) {
  return await apiService
    .setUrl(`/chats/${params.chatId}`)
    .setMethod("GET")
    .setParams(params)
    .request();
};
async function clearChat(chatId: number) {
  return await apiService
    .setUrl(`/chats/clear`)
    .setMethod("PUT")
    .setParams({ chatId })
    .request();
};

// PROFILE
async function getMyChats(params: IFetchArchivedChatParams) {
  return await apiService
    .setUrl(`/profile/my-chats`)
    .setMethod("GET")
    .setParams(params)
    .request<IProfileChatDto[]>();
};

const ChatApi = {
  getChats,
  getChatById,
  createChat,
  updateChat,
  clearChat,
  getMyChats
}

export default ChatApi;
